export default {
  contractDetail:{
    results:[]
  },
  applicationMaterial: {
    results: [],
  },
  applicationMaterialId: {
    results: [],
  },



  applicationInstrument: {
    results: [],
  },
  applicationInstrumentId: {
    results: [],
  },
 
 
 
  applicationTransport: {},
  applicationTransportId: {},




  applicationStatus: {
    results: [],
  },
  applicationAuthor: {
    results: [],
  },
  applicationType: [],
  applicationStatusTimeLine: {
    results: [],
  },
  applicationStatusTimeLineById: [],
  applicationStatusChildTimeLine: {
    results: [],
  },

  

  applicationStatusMovementTimeLine: {
    results: [],
  },
  applicationMaterialMovement: {
    results: [],
  },
  applicationInstrumentMovement: {
    results: [],
  },


  purchase: {
    results: [],
  },
  instrumentReturn: {
    results: [],
  },
  goodReturn: {
    results: [],
  },


  brigadeWorks: [],
  oneBrigadeWorks: [],
  workFiles: [],
  refreshViewMaterial: false,



  workPartialPayments: [],
  oneWorkPartialPayment: [],



  report_requirement_for_brigade: [],
  report_requirement_for_brigade_by_work_type: [],
  report_requirement_for_brigade_by_work_category: [],
  report_requirement_for_good: [],
  report_requirement_for_good_material_type: [],


  
  worker_write_off_for_good: [],
  worker_write_off_for_instrument: [],
}
